import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import'rxjs/add/observable/fromEvent';
import'rxjs/add/operator/filter';
import'rxjs/add/operator/debounceTime';
import'rxjs/add/operator/switch';
import'rxjs/add/operator/do';
import'rxjs/add/operator/distinctUntilChanged';
import'rxjs/add/observable/throw';
import'rxjs/add/operator/map';
import {NgSearchTypesEnum} from './ng-search-types.enum';
import {NgSearchInterface} from './ng-search.interface';
import {NgSearchService} from './ng-search.service';
import {NgPureDataTableEventService} from '../ng-pure-datatable-event.service';
import {Subject} from 'rxjs/Subject';
export class NgSearchComponent implements OnInit {
public search$ = new Subject<string>();
private static defaultAllSettings: NgSearchInterface<Object> = {
    path: null,
    placeholder: 'What are you looking for?',
    data: [],
    searchKeys: [],
    from: null,
    position: 'right',
    width: 40,
    positionStyle: {
      right: null,
      top: null
    },
    queryField: 'search',
    borderColor: '#eee000',
    buttonColor: '#83e6bc',
    searchType: NgSearchTypesEnum.EMPTY_TABLE_APPLY_BACKEND
  };

   allSettings: NgSearchInterface<Object> = {
    path: null,
    placeholder: 'What are you looking for?',
    data: [],
    searchKeys: [],
    from: null,
    position: 'right',
    positionStyle: {
      right: null,
      top: null
    },
    width: 40,
    queryField: 'search',
    borderColor: '#eee000',
    buttonColor: '#83e6bc',
    searchType: NgSearchTypesEnum.EMPTY_TABLE_APPLY_BACKEND
  };
public searching = false;
private copyData = [];
/**
 * @param {?} ngSearchService
 * @param {?} ngPureDataTableEventService
 */
constructor(private ngSearchService: NgSearchService,
private ngPureDataTableEventService: NgPureDataTableEventService) {
    this.search$
      .distinctUntilChanged()
      .debounceTime(400)
      .subscribe(
        res => {
          if (res && res.length > 1) {
            this.doSearch(res);
            return;
          }
          if (res.length === 0) {
            this.ngPureDataTableEventService.broadcast(this.allSettings.from, {type: 'search', result: this.copyData, data: this.copyData});
          }
        },
        err => {
        }
      );
  }
/**
 * This is used to set the border color for the div
 * @return {?}
 */
public setBorderColor() {
    return {'border-bottom': '3px solid ' + this.allSettings.borderColor};
  }
/**
 * This is used to style the button background
 * @return {?}
 */
public setButtonColor() {
    return {'background': this.allSettings.buttonColor};
  }
/**
 * This is used to initialize searching on a table.
 * @param {?} query
 * @return {?}
 */
doSearch(query) {
    this.copyData = JSON.parse(JSON.stringify(this.allSettings.data));
    if (!query) {
      return null;
    }
    this.searching = true;
    setTimeout(() => {
      switch (this.allSettings.searchType) {
        case NgSearchTypesEnum.EMPTY_TABLE_APPLY_BACKEND:
          this.processSearching(NgSearchTypesEnum.EMPTY_TABLE_APPLY_BACKEND, query);
          break;
        case NgSearchTypesEnum.ON_BACKEND:
          this.doSearchBackend(query);
          break;
        case NgSearchTypesEnum.ON_TABLE:
          this.processSearching(NgSearchTypesEnum.ON_TABLE, query);
          break;
        default:
          Observable.throw('Unknown search type');
          break;
      }
    }, 200);
  }
/**
 * This is used to search query strings
 * @param {?} type
 * @param {?} query
 * @return {?}
 */
private processSearching(type, query) {
    this.ngSearchService.initSearch(this.allSettings.data, query, this.allSettings.searchKeys)
      .subscribe(
        (result) => {
          // console.log('saerchResult=', result);
          if (result.length === 0 && type === NgSearchTypesEnum.EMPTY_TABLE_APPLY_BACKEND) {
            this.doSearchBackend(query);
            return;
          }
          this.ngPureDataTableEventService.broadcast(this.allSettings.from, {type: 'search', result: result, data: this.copyData});
          this.searching = false;
          // console.log('searching=', this.searching);
        },
        (err) => {
          this.searching = false;
          this.ngPureDataTableEventService.broadcast(this.allSettings.from, {type: 'search', error: err, data: this.copyData});
        }
      );
  }
/**
 * This is used to make a request to a backend api for searching.
 * @param {?} query
 * @return {?}
 */
private doSearchBackend(query) {
    const /** @type {?} */ pos = this.allSettings.path.indexOf('?');
    const /** @type {?} */ path = (pos > -1) ? this.allSettings.path + `&${this.allSettings.queryField}=${query}` : this.allSettings.path + `?${this.allSettings.queryField}=${query}`;
    this.ngSearchService.searchResource(path)
      .subscribe(
        (res) => {
          this.ngPureDataTableEventService.broadcast(this.allSettings.from, {type: 'search', result: res, data: this.copyData});
          this.searching = false;
        },
        (err) => {
          this.searching = false;
          this.ngPureDataTableEventService.broadcast(this.allSettings.from, {type: 'search', error: err, data: this.copyData});
        }
      );
  }
/**
 * This is used to validate object passed down to table searcher.
 * @return {?}
 */
ValidateSettings() {
    for (const /** @type {?} */ key in this.allSettings) {
      if (!this.allSettings[key]) {
        this.allSettings[key] = NgSearchComponent.defaultAllSettings[key];
      }
    }
  }
/**
 * @return {?}
 */
ngOnInit() {
    this.ValidateSettings();
    this.copyData = JSON.parse(JSON.stringify(this.allSettings.data));
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ng-search',
  template: `
    <div class="ng-search" [ngStyle]="setBorderColor()" [class.disabled]="searching">
    <input [disabled]="searching" (keyup)="search$.next(searchItem.value)" #searchItem  type="text"  placeholder="{{allSettings.placeholder}}">
      <!--<i *ngIf="searching" class="fa fa-spin fa-spinner"></i>-->
    <!--  <button  [disabled]="searching" type="button" (click)="doSearch(searchItem.value)" class="button" [ngStyle]="setButtonColor()">
        <i *ngIf="searching" class="fa fa-spin fa-spinner"></i> <i class="fa fa-search"></i>
      </button>-->
    </div>
    <span class="clearOut"></span>
  `,
  styles: [`
    input {
      width: 80% !important;
      border: 0 !important;
      height: 20px !important;
      padding: 5px !important;
    }

    input:visited, input:active, input:link, input:after, input:hover, input:focus, button:focus {
      border: 0 !important;
      outline: none;
    }

    .ng-search {
      border-radius: 5px !important;
      -moz-border-radius: 5px !important;
      -webkit-border-radius: 5px !important;
      width: 100% !important;
      color: #000;
      border: 1px solid #ccc;
      border-bottom: 3px solid #eee000;
      padding: 0 !important;
      margin: 0 !important;
      font-size: 11px !important;
    }

    .disabled {
      background: rgb(235, 235, 228) !important;
    }

    .button {
      background: #83e6bc;
      padding: 9px !important;
      color: #fff !important;
      border: 0 !important;
      cursor: pointer !important;
      font-size: 11px;
      float: right;
      border-radius: 0 5px 5px 0  !important;
      -moz-border-radius: 0 5px 5px 0 !important;
      -webkit-border-radius: 0 5px 5px 0 !important;
    }
    .clearOut {
      clear: both;
    }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgSearchService, },
{type: NgPureDataTableEventService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'allSettings': [{ type: Input },],
};
}

function NgSearchComponent_tsickle_Closure_declarations() {
/** @type {?} */
NgSearchComponent.defaultAllSettings;
/** @type {?} */
NgSearchComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgSearchComponent.ctorParameters;
/** @type {?} */
NgSearchComponent.propDecorators;
/** @type {?} */
NgSearchComponent.prototype.search$;
/** @type {?} */
NgSearchComponent.prototype.allSettings;
/** @type {?} */
NgSearchComponent.prototype.searching;
/** @type {?} */
NgSearchComponent.prototype.copyData;
/** @type {?} */
NgSearchComponent.prototype.ngSearchService;
/** @type {?} */
NgSearchComponent.prototype.ngPureDataTableEventService;
}





interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
